var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "talent-detail-container" },
    [
      _c("div", { staticClass: "talent-details" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.scholarInfoLoading,
                expression: "scholarInfoLoading",
              },
            ],
          },
          [_c("talent-info", { attrs: { "talent-data": _vm.talentData } })],
          1
        ),
        _c("div", {
          staticStyle: {
            "border-bottom": "1px dashed #eeeeee",
            margin: "6px 0 20px",
          },
        }),
        _c("div", { staticClass: "flex" }, [
          _vm.talentData.citationReportVisible
            ? _c(
                "div",
                {
                  class:
                    _vm.selectType === "学术综合能力"
                      ? "selectItemStyle"
                      : "itemStyle",
                  on: {
                    click: function ($event) {
                      return _vm.changeType("学术综合能力")
                    },
                  },
                },
                [_vm._v(" 学术综合能力 ")]
              )
            : _vm._e(),
          _c(
            "div",
            {
              class:
                _vm.selectType === "个人资料" ? "selectItemStyle" : "itemStyle",
              on: {
                click: function ($event) {
                  return _vm.changeType("个人资料")
                },
              },
            },
            [_vm._v(" 个人资料 ")]
          ),
          _c(
            "div",
            {
              class:
                _vm.selectType === "科研成果" ? "selectItemStyle" : "itemStyle",
              on: {
                click: function ($event) {
                  return _vm.changeType("科研成果")
                },
              },
            },
            [_vm._v(" 科研成果 ")]
          ),
          _c(
            "div",
            {
              class:
                _vm.selectType === "合作关系" ? "selectItemStyle" : "itemStyle",
              on: {
                click: function ($event) {
                  return _vm.changeType("合作关系")
                },
              },
            },
            [_vm._v(" 合作关系 ")]
          ),
          _c(
            "div",
            {
              class:
                _vm.selectType === "前沿分析" ? "selectItemStyle" : "itemStyle",
              on: {
                click: function ($event) {
                  return _vm.changeType("前沿分析")
                },
              },
            },
            [_vm._v(" 前沿分析 ")]
          ),
        ]),
        _c("div", [
          _vm.selectType === "学术综合能力"
            ? _c(
                "div",
                [
                  _c("talent-cites", {
                    ref: "talentCites",
                    attrs: {
                      "scholar-id": _vm.googleId,
                      "cites-per-year": _vm.citesPerYear,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectType === "个人资料",
                  expression: "selectType === '个人资料'",
                },
              ],
              staticClass: "personal-infor",
            },
            [
              _c(
                "div",
                { staticClass: "flex select-p-view" },
                _vm._l(_vm.personalInforTabs, function (tab, index) {
                  return _c(
                    "p",
                    {
                      key: index,
                      staticClass: "pointer",
                      class: { active: _vm.activePersonalInfor === tab },
                      on: { click: () => (_vm.activePersonalInfor = tab) },
                    },
                    [_vm._v(" " + _vm._s(tab) + " ")]
                  )
                }),
                0
              ),
              _c("talent-info-dialog", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activePersonalInfor === "个人资料",
                    expression: "activePersonalInfor === '个人资料'",
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.scholarInfoLoading,
                    expression: "scholarInfoLoading",
                  },
                ],
                ref: "talentInfoDialog",
                attrs: { "talent-data": _vm.talentData },
              }),
              _c("ai-personal-information", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activePersonalInfor === "AI检索",
                    expression: "activePersonalInfor === 'AI检索'",
                  },
                ],
                attrs: {
                  "scholar-name": _vm.talentData.scholarVO?.scholarName,
                  "scholar-org": _vm.talentData.scholarVO?.scholarOrg,
                  scholarId: _vm.scholarId,
                },
              }),
            ],
            1
          ),
          _vm.selectType === "科研成果"
            ? _c(
                "div",
                [
                  _c("achievement-list", {
                    attrs: { "scholar-id": _vm.scholarId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.selectType === "合作关系"
            ? _c(
                "div",
                [
                  _c("cooperation-view", {
                    attrs: { "scholar-id": _vm.scholarId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.selectType === "前沿分析"
            ? _c(
                "div",
                [
                  _c("analysis-view", {
                    attrs: {
                      "scholar-id": _vm.scholarId,
                      "field-tow-e-names": _vm.talentData.scholarVO.fields,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c("paymentDialog", {
        ref: "scholarDetailPayment",
        attrs: { payType: "人才详情" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }